export default "__VITE_ASSET__D9N3QygI__"